export default __webpack_public_path__ + "static/media/wowbottom.a5a93363.png";